<template>
    <div class="card">
        <!-- <TabView @tab-change="handleTabChange"> -->
            <TabView >
            <TabPanel header="รายละเอียด">
                <report-victim-detail></report-victim-detail>
            </TabPanel>
            <TabPanel header="สรุปจำนวนผู้ประสบภัย">
                <report-victim-amount></report-victim-amount>
            </TabPanel>
            <TabPanel header="กราฟตามประเภทสาธารณภัย (รายเดือน)">
                <report-victim-disaster-graph-month></report-victim-disaster-graph-month>
            </TabPanel>
            <TabPanel header="กราฟตามประเภทสาธารณภัย (รายปี)">
                <report-victim-disaster-graph-year></report-victim-disaster-graph-year>
            </TabPanel>
            <TabPanel header="กราฟตามพื้นที่เกิดเหตุ (รายเดือน)">
                <report-victim-location-graph-month></report-victim-location-graph-month>
            </TabPanel>
            <TabPanel header="กราฟตามพื้นที่เกิดเหตุ (รายปี)">
                <report-victim-location-graph-year></report-victim-location-graph-year>
            </TabPanel>
            <TabPanel header="สรุปมูลค่าขอความช่วยเหลือ">
                <report-victim-conclusion></report-victim-conclusion>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import reportVictimDetail from './ReportVictimDetail';
import reportVictimAmount from './ReportVictimAmount';
import reportVictimDisasterGraphMonth from './ReportVictimDisasterGraphMonth';
import reportVictimDisasterGraphYear from './ReportVictimDisasterGraphYear';
import reportVictimLocationGraphMonth from './ReportVictimLocationGraphMonth';
import reportVictimLocationGraphYear from './ReportVictimLocationGraphYear';
import reportVictimConclusion from './ReportVictimConclusion';

export default {
    components: {
        reportVictimDetail,
        reportVictimAmount,
        reportVictimDisasterGraphMonth,
        reportVictimDisasterGraphYear,
        reportVictimLocationGraphMonth,
        reportVictimLocationGraphYear,
        reportVictimConclusion
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>